import currency from 'currency.js';

const costFormat = (value: number) => {
  return `${currency(value, { symbol: '', separator: ' ', decimal: '.', precision: 2 }).format()}`;
};

const costFormatWithCurrency = (amount: number, symbol = '₸') => {
  return `${currency(amount, { symbol: '', separator: ' ', decimal: '.' }).format()} ${symbol}`;
};

export { costFormat, costFormatWithCurrency };
